<template>

    <div style="background-color: #f7f7f7; width: 99%; height: 100vh; padding: 8px 8px 0 8px;">
        <hSearchForm ref="hSearchForm" :searchItems="searchItems" @handleSearch="handleSearch" />

        <hTable ref="hTable" style="margin-top: 20px" :tableProps="tableProps" :queryParams="queryParams"
            functionKey="getKeyPageList" :operateButtons="operateButtons" @emitButtonKey="emitButtonKey" />

    </div>

</template>
<script setup>
import useUserStore from "@/store/modules/user";
import { getProvincesDetail } from '@/api/home'
import { getCurrentInstance, ref } from 'vue';
import { useRouter } from "vue-router";
import { tableProps, searchItems, operateButtons } from "./keyListConfig";
const { proxy } = getCurrentInstance();
let queryParams = ref({})
const router = useRouter()
function handleSearch(params, isButtonSearch) {
    queryParams.value = params;
    proxy.$refs["hTable"].getList(queryParams.value, isButtonSearch);
}

function emitButtonKey(data) {
    if (data.key === 'login') {
        doLogin(data)
    }
}
function doLogin(data) {
    useUserStore()
        .wanKeylogin(data.rowData.userId)
        .then((res) => {

            if (res.success) {
                proxy.$message.success("登录成功");
                useUserStore().getInfo().then(rs => {
                    router.push('/detail')
                })

            } else {
                proxy.$message.error(res.message);
            }

        })

}
</script>
